import {useRef} from 'react';

import {SimpleGrid, Text} from '@mantine/core';

import {NavLink} from 'react-router-dom';

import {useCustomerSubscriptions} from '../hooks/useCustomerSubscriptions.ts';
import {useCustomerSubscriptionsSelection} from '../hooks/useCustomerSubscriptionsSelection.ts';
import {useTableColumns} from '../hooks/useTableColumns.tsx';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import {DataTableTokenPagination} from "../../../components/DataTableTokenPagination.tsx";
import {CustomerSubscription} from '../types';

export const RecordsTable = () => {
    const {columns} = useTableColumns('customer');
    const {selectedRecords, setSelectedRecords} = useCustomerSubscriptionsSelection();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useCustomerSubscriptions();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            <MantineDataTable
                // FNP-322: items column is now the NavLink into the detail page;
                // edits go through the EditPage's top-bar Edit button instead of
                // an in-row drawer.
                columns={columns.map(col => {
                    if (col.accessor === 'items') {
                        return {
                            ...col,
                            render: (record: CustomerSubscription) => {
                                const recordItems = Array.isArray(record.items?.items) ? record.items.items : [];
                                const detailHref = `/customer-subscriptions/${record.id}`;

                                if (recordItems.length === 0) {
                                    return (
                                        <NavLink to={detailHref} style={{textDecoration: 'none'}}>
                                            <Text c="blue" size="sm">Empty subscription</Text>
                                        </NavLink>
                                    );
                                }

                                return (
                                    <NavLink to={detailHref} style={{textDecoration: 'none'}}>
                                        {recordItems.slice(0, 2).map((item, index) => (
                                            <Text key={index} size="sm" c="blue">
                                                {item.price?.product?.name || `Price ${item.priceId}`} (x{item.quantity})
                                            </Text>
                                        ))}
                                        {recordItems.length > 2 &&
                                            <Text size="xs" c="dimmed">+{recordItems.length - 2} more</Text>}
                                    </NavLink>
                                );
                            }
                        };
                    }
                    return col;
                })}
                records={items as CustomerSubscription[]}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken}
                                      handleLoadMore={fetchRecords}/>
        </SimpleGrid>
    );
};
